// extracted by mini-css-extract-plugin
var _1 = "GretaAIChatMessageListTurns-modulegroupGap__hw1i9";
var _2 = "GretaAIChatMessageListTurns-moduleturnGap__CQjZ6";
export { _1 as "groupGap", _2 as "turnGap" }
